import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HintTooltipComponent } from './components';
import { HintTooltipDirective } from './directives';
import { TranslateModule } from '@ngx-translate/core';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';

@NgModule({
  declarations: [HintTooltipDirective, HintTooltipComponent],
  imports: [CommonModule, NzPopoverModule, TranslateModule, CustomModalModule],
  exports: [HintTooltipDirective, HintTooltipComponent],
})
export class CustomTooltipModule {}
